export default __webpack_public_path__ + "static/media/level-complete-image3.101b8c49.png";